<div class="absolute top-0 flex flex-col items-center justify-center w-full h-full min-h-screen p-8 text-center bg-almost-white">
	<div class="text-xl font-extrabold font-header">{{ 'unavailable-view.message' | translate }}</div>
</div>
